'use strict';

var query = function query(a) {
  return document.querySelector("[data-name=\"modal-".concat(a, "\"]"));
};

module.exports = query;